<template>
  <HelloWorld msg="Welcome Morten to Your Vue.js App"/>
  <MyVideo  />

  <MyComponent />
  
  <BatteryState ref="battery" />
 
  <ShellSensor ref="shellSensor" />
</template>

<script>
import BatteryState from './components/BatteryState.vue'
import HelloWorld from './components/HelloWorld.vue'
import MyComponent from './components/MyComponent.vue'
import ShellSensor from   './components/ShellSensor.vue'
import MyVideo from './components/MyVideo.vue'

export default {
  name: 'App',
  components: {
    HelloWorld,
    MyComponent,
    BatteryState,
    ShellSensor,
    MyVideo
  }
}
</script>

<style >
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
